import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { LandlordCertificate } from '@modules/services/landlordCertificate/LandlordCertificate';

const TITLE = 'Landlord Certificate Services in London | Qeeper';
const DESC =
  'Landlord certificate services in London. Keep your rental property compliant and your tenants safe with gas safety,  electrical certificates and more. ';
const URL = 'https://www.qeeper.co.uk/services/landlord-certificate';
const SEO_KEYWORDS =
  'landlord cert, electrical certificates for landlords, gas certificate landlords, eicr certificate near me';

const LandlordCertificatePage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <LandlordCertificate />
    </>
  );
};

export default LandlordCertificatePage;
